import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteIndustrialProcessMutation} from 'api';
import {useSnackbar} from 'notistack';

function IndustrialProcessDeleteIconButton({industrialProcessId}) {
  const [deleteIndustrialProcess, deleteIndustrialProcessResult] =
    useDeleteIndustrialProcessMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteIndustrialProcess(industrialProcessId).unwrap();
      enqueueSnackbar('IndustrialProcess deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting IndustrialProcess`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete IndustrialProcess</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Process?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteIndustrialProcessResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteIndustrialProcessResult.isLoading}
            color="error"
            endIcon={
              deleteIndustrialProcessResult.isLoading ? <CircularProgress size={16} /> : null
            }
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteIndustrialProcessResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default IndustrialProcessDeleteIconButton;
